import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";

const InfoContainer = ({ title, description, type, number, imageSrc }) => {
  return (
    <Col xs={15} md={20} className="tech-icons">
      <h3>
        <strong>{title}</strong>
      </h3>
      <p
        style={{
          color: "white",
          fontSize: "15px",
          paddingLeft: 50,
          paddingRight: 50,
        }}
      >
        {description} <br />
        <span style={{ color: "#fdf902" }}>
          {type} {number}
        </span>
      </p>
      <img
        src={imageSrc}
        alt=""
        className="img-fluid"
        style={{ maxWidth: "100px" }}
      />
    </Col>
  );
};

InfoContainer.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
};

export default InfoContainer;
